
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/szolgaltatasok/csoport",
      function () {
        return require("private-next-pages/szolgaltatasok/csoport.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/szolgaltatasok/csoport"])
      });
    }
  